/* ==========================================================================
   Makefield — gift card product page
   --------------------------------------------------------------------------
   The design puts the quantity stepper and Add to cart on one row. Dawn
   renders the quantity as its own block outside the <form>, with the
   gift-recipient checkbox in between, so CSS alone could only pair them with
   an offset the size of that checkbox — a value that drifts as its text wraps
   or the locale changes.

   This moves the stepper next to the buttons once, wraps the pair in a row,
   and lets section-mk-giftcard.css lay them out. Without JS the page keeps
   Dawn's ordinary stacked layout, which still works.

   Scoped to the gift-card template so no other product is affected.
   ========================================================================== */

(function () {
  'use strict';

  function pair(root) {
    var quantity = root.querySelector('.product-form__quantity');
    var buttons = root.querySelector('.product-form__buttons');
    if (!quantity || !buttons) return;

    /* Already paired — the section can re-render in the theme editor. */
    if (buttons.parentElement && buttons.parentElement.classList.contains('mk-gc-row')) {
      return;
    }

    var row = document.createElement('div');
    row.className = 'mk-gc-row';

    /* Insert the row where the buttons are, then move both into it — order
       matters so the stepper lands on the left, as the design shows. */
    buttons.parentNode.insertBefore(row, buttons);
    row.appendChild(quantity);
    row.appendChild(buttons);
  }

  function initAll() {
    document
      .querySelectorAll('[data-template-suffix="gift-card"] .product__info-container')
      .forEach(pair);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  /* The buy-buttons block re-renders when a variant changes, which can put a
     fresh .product-form__buttons back outside the row. */
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('variant:change', initAll);
})();
